import { Box, SvgIconProps } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import Sidebar from 'components/sidebar'
import InsightsFab from 'components/insights-fab'
import { useAuth } from 'contexts/auth'
import usePageVisibilityWithTimeout from 'hooks/use-page-visibility-with-timeout'
import { PropsWithChildren, ReactElement, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

export interface ISubMenuOption {
  id: string
  icon: ReactElement<SvgIconProps>
  text: string
  route: string
  subMenuOptions?: ISubMenuOption[]
  isOnlyApi: boolean
}

export interface IMenuOption {
  id: string
  icon: ReactElement<SvgIconProps>
  text: string
  route: string
  subMenuOptions: ISubMenuOption[]
  isOnlyApi: boolean
}

const DefaultLayout = ({ children }: PropsWithChildren) => {
  const history = useHistory()
  const classes = useStyles()

  const { user } = useAuth()

  usePageVisibilityWithTimeout()

  const validationRedirects = async () => {
    if (user && !user.emailIsConfirmed) {
      return history.push('/verify-email')
    }
  }

  useEffect(() => {
    validationRedirects()
  }, [])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box className={classes.container}>
        <Sidebar />
        {children}
        <InsightsFab />
      </Box>
    </LocalizationProvider>
  )
}

export default DefaultLayout
